import { AfterViewInit, Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterModule } from '@angular/router';

@Component({
  selector: 'app-reports-dashboard',
  standalone: true,
  imports: [
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    RouterModule
  ],
  templateUrl: './reports-dashboard.component.html',
  styleUrl: './reports-dashboard.component.scss'
})
export class ReportsDashboardComponent implements OnInit, AfterViewInit {

  constructor(
    private router: Router
  ) {}

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
  }

  navigateToJobCardReport() {
    this.router.navigate(['/app/reports/job-card-report']);
  }

  navigateToComplaintReport() {
    this.router.navigate(['/app/reports/complaint-report']);
  }

  navigateToComplaintsSummaryReport() {
    this.router.navigate(['/app/reports/complaints-summary-report']);
  }

  navigateToJasperReports() {
    this.router.navigate(['/app/reports/jasper-report']);
  }

}
